import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/styles';
import { Route, withRouter } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import clsx from 'clsx';

import Header from '../../core/Header';
import Footer from '../../core/Footer';
import Steps from '../steps/Container';
import LoadingOverlay from '../../core/LoadingOverlay';
import { StartupConfig } from '../../startupconfig';
import { TelemetryProvider } from '../../telemetryprovider';
import Mouseflow from '../../insights/Mouseflow';
import GlobalSessionHandler from '../../globalSessionHandler/GlobalSessionHandler';
import { ReferralWelcome } from '../referralwelcome';
import asyncSessionStorage from '../../../utils/asyncSessionStorage';
import { SESSION_URL } from '../../../constants';

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: '100vh',
    position: 'relative',
    paddingBottom: 35,
  },
  hidden: {
    display: 'none',
  },
}));

const Main = ({
  isLoading,
  loadingMessage,
  loadingVariant,
  headerLogo,
  configuration,
  isConfigurationSet,
  getStartupConfig,
  restartWorkflow,
  location,
}) => {
  const classes = useStyles();

  // to support browser refresh, save url to browser session as url gets re-written
  if (!asyncSessionStorage.getItemSync(SESSION_URL)) {
    asyncSessionStorage.setItem(SESSION_URL, window.location.href);
  }

  return (
    <Fragment>
      {isLoading && (
        <LoadingOverlay indicatorSize={40} message={loadingMessage} variant={loadingVariant} />
      )}
      <StartupConfig
        configuration={configuration}
        isConfigurationSet={isConfigurationSet}
        getStartupConfig={getStartupConfig}
      />
      <TelemetryProvider configuration={configuration} isConfigurationSet={isConfigurationSet}>
        <Mouseflow />
        <GlobalSessionHandler callbackOnTimeout={restartWorkflow} />
        <Route exact path="/referral-welcome" component={ReferralWelcome} />
        <div
          className={clsx(classes.container, {
            [classes.hidden]: location.pathname === '/referral-welcome',
          })}
        >
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item xs={12}>
              <Header Logo={headerLogo} />
            </Grid>
            <Grid item xs={12}>
              <Steps />
            </Grid>
          </Grid>
          <Footer />
        </div>
      </TelemetryProvider>
    </Fragment>
  );
};

Main.propTypes = {
  isLoading: PropTypes.bool,
  loadingMessage: PropTypes.string,
  loadingVariant: PropTypes.oneOf(['default', 'success']),
  headerLogo: PropTypes.any.isRequired,
  configuration: PropTypes.object,
  isConfigurationSet: PropTypes.bool,
  getStartupConfig: PropTypes.func.isRequired,
  restartWorkflow: PropTypes.func.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
};

Main.defaultProps = {
  isLoading: false,
  loadingMessage: 'Just a moment...',
  loadingVariant: 'default',
  configuration: null,
  isConfigurationSet: false,
};

export default withRouter(Main);
